import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';
import _ from 'lodash';

import { APIgetRoles } from '../../../api/Roles';

import { getBuiltInRoles } from '../../../helpers/Users';

const AdminUsersFiltersSelector = ({
  counts,
  userActivationStatuses,
  selectedUserActivationStatuses,
  selectedRoles,
  handleChangeFilter,
}) => {
  const intl = useIntl();

  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const fetchRoles = async () => {
      const builtInRoles = _.sortBy(
        getBuiltInRoles().map(role => ({
          id: role.value,
          name: role.label,
          description: role.description,
        })),
        'id',
      );

      const response = await APIgetRoles({ all: true });

      setRoles([...builtInRoles, ...response.data]);
    };

    fetchRoles();
  }, []);

  if (Object.keys(userActivationStatuses).length === 0) {
    return null;
  }

  const hasActiveFilters =
    selectedUserActivationStatuses.filter(status => status !== 'all').length > 0
    || selectedRoles.filter(role => role !== 'all').length > 0;

  return (
    <UncontrolledDropdown className="filter-statuses filter-statuses-users">
      <DropdownToggle caret className={`btn-sm${hasActiveFilters ? ' has-active-filters' : ''}`}>
        {intl.formatMessage({ defaultMessage: 'Filters' })}
        {hasActiveFilters && <span className="filters-active-dot" aria-hidden="true" />}
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem header>
          {intl.formatMessage({ defaultMessage: 'Statuses' })}
        </DropdownItem>

        <DropdownItem
          toggle={false}
          onClick={() => handleChangeFilter({
            target: {
              name: 'selectedUserActivationStatuses',
              value: 'all',
              checked: !selectedUserActivationStatuses.length,
              type: 'checkbox',
            },
          })}
        >
          {selectedUserActivationStatuses.includes('all') && (
          <i className="far fa-check" />
          )}
          {' '}{intl.formatMessage({ defaultMessage: 'All' })} ({counts.all || 0})
        </DropdownItem>

        {Object.keys(userActivationStatuses).map(statusId => (
          <DropdownItem
            key={statusId}
            toggle={false}
            onClick={() => handleChangeFilter({
              target: {
                name: 'selectedUserActivationStatuses',
                value: statusId,
                checked: !selectedUserActivationStatuses.includes(statusId),
                type: 'checkbox',
              },
            })}
          >
            {selectedUserActivationStatuses.includes(statusId) && (
            <i className="far fa-check" />
            )}
            {' '}
            {userActivationStatuses[statusId]} ({counts[statusId] || 0})
          </DropdownItem>
        ))}

        <DropdownItem divider />

        <DropdownItem header>
          {intl.formatMessage({ defaultMessage: 'Roles' })}
        </DropdownItem>

        <DropdownItem
          toggle={false}
          onClick={() => handleChangeFilter({
            target: {
              name: 'selectedRoles',
              value: 'all',
              checked: selectedRoles.length === 0 || !selectedRoles.includes('all'),
              type: 'checkbox',
            },
          })}
        >
          {(selectedRoles.length === 0 || selectedRoles.includes('all')) && (
            <i className="far fa-check" />
          )}
          {' '}
          {intl.formatMessage({ defaultMessage: 'All' })}
        </DropdownItem>

        {roles.map(role => (
          <DropdownItem
            key={role.id}
            toggle={false}
            onClick={() => handleChangeFilter({
              target: {
                name: 'selectedRoles',
                value: `${role.id}`,
                checked: !selectedRoles.includes(`${role.id}`),
                type: 'checkbox',
              },
            })}
          >
            {selectedRoles.includes(`${role.id}`) && <i className="far fa-check" />}
            {' '}
            {role.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

AdminUsersFiltersSelector.propTypes = {
  counts: PropTypes.object.isRequired,
  userActivationStatuses: PropTypes.object.isRequired,
  selectedUserActivationStatuses: PropTypes.array.isRequired,
  selectedRoles: PropTypes.array.isRequired,
  handleChangeFilter: PropTypes.func.isRequired,
};

export default AdminUsersFiltersSelector;
